module.exports = __webpack_public_path__ + "static/media/flutterwave-logos-idVM8GW1LQ.95e5acb2.png";